module.exports = __webpack_public_path__ + "img/64.5d185cb6.svg";